import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"
import _imports_0 from '@/assets/icons/checked-text-header.svg'
import _imports_1 from '@/assets/icons/arrow-customize-builder.svg'


const _hoisted_1 = { class: "page-wr" }
const _hoisted_2 = {
  key: 1,
  class: "spinner"
}
const _hoisted_3 = {
  key: 2,
  class: "empty-block--wrapper"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = ["id"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "instructions-steps" }
const _hoisted_11 = { class: "content-steps" }
const _hoisted_12 = { class: "content-instructions-step" }
const _hoisted_13 = { class: "content-dropdown-lot" }
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "content-number-step" }
const _hoisted_16 = { class: "number-step" }
const _hoisted_17 = {
  key: 1,
  class: "content-instructions-step"
}
const _hoisted_18 = { class: "content-number-step" }
const _hoisted_19 = { class: "number-step" }
const _hoisted_20 = {
  key: 2,
  class: "content-instructions-step"
}
const _hoisted_21 = { class: "content-number-step" }
const _hoisted_22 = { class: "number-step" }
const _hoisted_23 = {
  key: 3,
  class: "content-instructions-step"
}
const _hoisted_24 = { class: "content-number-step" }
const _hoisted_25 = { class: "number-step" }
const _hoisted_26 = {
  key: 2,
  class: "stage-list"
}
const _hoisted_27 = {
  key: 1,
  class: "content-builder-desktop"
}
const _hoisted_28 = { class: "content-step-two" }
const _hoisted_29 = { class: "content-step-three" }
const _hoisted_30 = { class: "content-step-five" }
const _hoisted_31 = {
  key: 2,
  class: "content-builder-mobile"
}
const _hoisted_32 = { class: "content-builder-selection" }
const _hoisted_33 = {
  key: 0,
  class: "content-footer-desktop"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (!$setup.loading && !$setup.isDesktop)
        ? (_openBlock(), _createBlock($setup["BuilderHeader"], {
            key: 0,
            estate: $setup.estate,
            builderLogo: $setup.selectedBuilder?.logo,
            skipStepIndex: $setup.skipStepIndex,
            onOnRequestQuotes: $setup.onRequestQuotes
          }, {
            stepper: _withCtx(() => [
              _createVNode($setup["StepperLineDesktop"], {
                tabs: [...Object.values($setup.CustomizeHouseStepsEnum)],
                step: $setup.selectedQuote.currentStep,
                skipStep: $setup.skipStep,
                skipStepIndex: $setup.skipStepIndex,
                onToReturnMap: $setup.onReturnMap
              }, null, 8, ["tabs", "step", "skipStep", "skipStepIndex"])
            ]),
            _: 1
          }, 8, ["estate", "builderLogo", "skipStepIndex"]))
        : _createCommentVNode("", true),
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2))
        : (!$setup.loading && !$setup.lotHasBuilders)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                class: "empty-block--icon",
                src: require('@/assets/icons/icon-error.svg')
              }, null, 8, _hoisted_4),
              _cache[9] || (_cache[9] = _createElementVNode("p", null, "This lot does not have builders.", -1)),
              _createElementVNode("button", {
                class: "button default outlined",
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.go(-1)))
              }, "Go Back")
            ]))
          : (_openBlock(), _createElementBlock("div", {
              key: 3,
              class: _normalizeClass(["content-wr", { 'size-height': ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.HOUSE && !$setup.isDesktop) || $setup.currentStepIndex == $setup.SelectionStepsIndexEnum.CONFIRMATION || ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.LOT && $setup.isStageListOpen && $setup.isChangeSize && !$setup.isDesktop) }])
            }, [
              ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.LOT)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "header",
                    id: $setup.BuilderStepsIds.LOT
                  }, [
                    ($setup.isDesktop)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "title" }, "Create your own home and land package and", -1)),
                          _createElementVNode("h1", _hoisted_7, "request a quote in " + _toDisplayString($setup.stepsNumbers[3]) + " simple steps.", 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _cache[11] || (_cache[11] = _createElementVNode("h1", { class: "title" }, [
                            _createTextVNode("Create your own"),
                            _createElementVNode("span", null, "home and land")
                          ], -1)),
                          _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "title" }, [
                            _createElementVNode("span", null, "package"),
                            _createTextVNode(" and request a quote in")
                          ], -1)),
                          _createElementVNode("h1", _hoisted_9, _toDisplayString($setup.stepsNumbers[3]) + " simple steps.", 1)
                        ])),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "content-number-step-checked" }, [
                            _createElementVNode("img", {
                              class: "icon-checked",
                              src: _imports_0
                            })
                          ], -1)),
                          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "content-text-step" }, [
                            _createElementVNode("span", { class: "text-step" }, "Select your lot:")
                          ], -1)),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("button", {
                              class: _normalizeClass(["dropdown-button stage-list", { active: $setup.fadeInEffect }]),
                              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.openStageList()))
                            }, "Lot " + _toDisplayString($setup.lot.title), 3)
                          ])
                        ]),
                        (!$setup.isStageListOpen && !$setup.hasToSkipStep2)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "content-instructions-step",
                              id: $setup.BuilderStepsIds.PREVIEW_BUILDER
                            }, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("span", _hoisted_16, _toDisplayString($setup.stepsNumbers[0]), 1)
                              ]),
                              _cache[15] || (_cache[15] = _createElementVNode("div", { class: "content-text-step" }, [
                                _createElementVNode("span", { class: "text-step" }, "Select a builder to view home designs")
                              ], -1))
                            ], 8, _hoisted_14))
                          : _createCommentVNode("", true),
                        (!$setup.isStageListOpen)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("span", _hoisted_19, _toDisplayString($setup.stepsNumbers[1]), 1)
                              ]),
                              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "content-text-step" }, [
                                _createElementVNode("span", { class: "text-step" }, "Select your design")
                              ], -1))
                            ]))
                          : _createCommentVNode("", true),
                        (!$setup.isStageListOpen)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                _createElementVNode("span", _hoisted_22, _toDisplayString($setup.stepsNumbers[2]), 1)
                              ]),
                              _cache[17] || (_cache[17] = _createElementVNode("div", { class: "content-text-step" }, [
                                _createElementVNode("span", { class: "text-step" }, "Select your exterior facade")
                              ], -1))
                            ]))
                          : _createCommentVNode("", true),
                        (!$setup.isStageListOpen)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("span", _hoisted_25, _toDisplayString($setup.stepsNumbers[3]), 1)
                              ]),
                              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "content-text-step" }, [
                                _createElementVNode("span", { class: "text-step" }, "Confirm selections & request quote")
                              ], -1))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    ($setup.isStageListOpen)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createVNode($setup["StageList"], {
                            isEmbedded: _ctx.isEmbedded,
                            estate: $setup.estate,
                            viewType: 'list',
                            mapPage: $setup.MapPages.STAGE_LIST,
                            isBuilderView: true,
                            lotSelected: $setup.lotForModal,
                            onSelectLot: $setup.onSelectLot,
                            onChangeSize: $setup.onChangeSize
                          }, null, 8, ["isEmbedded", "estate", "mapPage", "lotSelected"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_5))
                : _createCommentVNode("", true),
              ($setup.currentStepIndex > $setup.SelectionStepsIndexEnum.LOT && $setup.isDesktop)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.BUILDER)
                      ? (_openBlock(), _createBlock($setup["BuilderSelection"], {
                          key: 0,
                          id: $setup.BuilderStepsIds.BUILDER,
                          items: $setup.builders,
                          selectedItem: $setup.selectedBuilder,
                          onOnSelectItem: $setup.onSelectBuilder
                        }, null, 8, ["id", "items", "selectedItem"]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", {
                      class: "content-step-two-and-three",
                      style: _normalizeStyle({ display: $setup.currentStepIndex != $setup.SelectionStepsIndexEnum.HOUSE ? 'none' : 'flex' })
                    }, [
                      _createElementVNode("div", _hoisted_28, [
                        ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.HOUSE)
                          ? (_openBlock(), _createBlock($setup["BuilderSelectionHouse"], {
                              key: 0,
                              id: $setup.BuilderStepsIds.HOUSE,
                              selectedHouseDesign: $setup.selectedHouseDesign,
                              selectedBuilder: $setup.selectedBuilder,
                              onOnRequestQuotes: $setup.onRequestQuotes,
                              onOnButtonStepVisibly: $setup.onButtonStepVisibly
                            }, null, 8, ["id", "selectedHouseDesign", "selectedBuilder"]))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.HOUSE)
                          ? (_openBlock(), _createBlock($setup["BuilderFloorplans"], {
                              key: 0,
                              id: $setup.BuilderStepsIds.FLOORPLAN,
                              houseDesign: $setup.selectedHouseDesign,
                              selectedQuote: $setup.selectedQuote,
                              onOnRequestQuotes: $setup.onRequestQuotes
                            }, null, 8, ["id", "houseDesign", "selectedQuote"]))
                          : _createCommentVNode("", true)
                      ])
                    ], 4),
                    _createElementVNode("div", {
                      class: "content-step-four",
                      style: _normalizeStyle({ display: $setup.currentStepIndex != $setup.SelectionStepsIndexEnum.FACADES ? 'none' : 'flex' })
                    }, [
                      ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.FACADES)
                        ? (_openBlock(), _createBlock($setup["BuilderSelectionFacades"], {
                            key: 0,
                            id: $setup.BuilderStepsIds.FACADE,
                            selectedHouseDesign: $setup.selectedHouseDesign,
                            selectedBuilder: $setup.selectedBuilder,
                            onOnRequestQuotes: $setup.onRequestQuotes,
                            onOnButtonStepVisiblyConfirmation: $setup.onButtonStepVisiblyConfirmation,
                            onOnButtonStepVisiblyConfirmationOff: $setup.onButtonStepVisiblyConfirmationOff
                          }, null, 8, ["id", "selectedHouseDesign", "selectedBuilder"]))
                        : _createCommentVNode("", true)
                    ], 4),
                    _createElementVNode("div", _hoisted_30, [
                      ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.CONFIRMATION)
                        ? (_openBlock(), _createBlock($setup["BuilderQuotesLists"], {
                            key: 0,
                            id: $setup.BuilderStepsIds.CONFIRMATION,
                            isOpen: $setup.isOpenBuilderQuotesListsModal,
                            houseDesign: $setup.selectedHouseDesign,
                            estate: $setup.estate,
                            lot: $setup.lot,
                            lotForBuilder: $setup.lotForBuilder,
                            onClose: _cache[2] || (_cache[2] = ($event: any) => ($setup.isOpenBuilderQuotesListsModal = false)),
                            onAddQuote: $setup.onAddQuote,
                            onUpdateQuoteBuilder: $setup.onUpdateQuoteBuilder,
                            onUpdateQuoteDesignAndFloorplan: $setup.onUpdateQuoteDesignAndFloorplan,
                            onUpdateQuoteFacade: $setup.onUpdateQuoteFacade,
                            onDeleteQuote: $setup.onDeleteQuote,
                            onToRequestQuoteForm: $setup.openRequestQuotesFormModal
                          }, null, 8, ["id", "isOpen", "houseDesign", "estate", "lot", "lotForBuilder"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true),
              ($setup.currentStepIndex > $setup.SelectionStepsIndexEnum.LOT && !$setup.isDesktop)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.BUILDER)
                        ? (_openBlock(), _createBlock($setup["BuilderSelection"], {
                            key: 0,
                            id: $setup.BuilderStepsIds.BUILDER,
                            items: $setup.builders,
                            selectedItem: $setup.selectedBuilder,
                            onOnSelectItem: $setup.onSelectBuilder
                          }, null, 8, ["id", "items", "selectedItem"]))
                        : _createCommentVNode("", true),
                      ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.HOUSE)
                        ? (_openBlock(), _createBlock($setup["BuilderSelectionHouse"], {
                            key: 1,
                            id: $setup.BuilderStepsIds.HOUSE,
                            selectedHouseDesign: $setup.selectedHouseDesign,
                            selectedBuilder: $setup.selectedBuilder,
                            onOnRequestQuotes: $setup.onRequestQuotes,
                            onOnFeaturesHidden: $setup.onFeaturesHidden,
                            onOnFeaturesVisibly: $setup.onFeaturesVisibly
                          }, null, 8, ["id", "selectedHouseDesign", "selectedBuilder"]))
                        : _createCommentVNode("", true),
                      ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.HOUSE)
                        ? (_openBlock(), _createBlock($setup["BuilderFloorplans"], {
                            key: 2,
                            id: $setup.BuilderStepsIds.FLOORPLAN,
                            houseDesign: $setup.selectedHouseDesign,
                            selectedQuote: $setup.selectedQuote,
                            isFeaturesHidden: true,
                            onOnRequestQuotes: $setup.onRequestQuotes
                          }, null, 8, ["id", "houseDesign", "selectedQuote"]))
                        : _createCommentVNode("", true),
                      ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.FACADES)
                        ? (_openBlock(), _createBlock($setup["BuilderSelectionFacades"], {
                            key: 3,
                            id: $setup.BuilderStepsIds.FACADE,
                            selectedHouseDesign: $setup.selectedHouseDesign,
                            selectedBuilder: $setup.selectedBuilder,
                            onOnRequestQuotes: $setup.onRequestQuotes
                          }, null, 8, ["id", "selectedHouseDesign", "selectedBuilder"]))
                        : _createCommentVNode("", true),
                      ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.CONFIRMATION)
                        ? (_openBlock(), _createBlock($setup["BuilderQuotesLists"], {
                            key: 4,
                            id: $setup.BuilderStepsIds.CONFIRMATION,
                            isOpen: $setup.isOpenBuilderQuotesListsModal,
                            houseDesign: $setup.selectedHouseDesign,
                            estate: $setup.estate,
                            lot: $setup.lot,
                            lotForBuilder: $setup.lotForBuilder,
                            onClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.isOpenBuilderQuotesListsModal = false)),
                            onAddQuote: $setup.onAddQuote,
                            onUpdateQuoteBuilder: $setup.onUpdateQuoteBuilder,
                            onUpdateQuoteDesignAndFloorplan: $setup.onUpdateQuoteDesignAndFloorplan,
                            onUpdateQuoteFacade: $setup.onUpdateQuoteFacade,
                            onDeleteQuote: $setup.onDeleteQuote,
                            onToRequestQuoteForm: $setup.openRequestQuotesFormModal
                          }, null, 8, ["id", "isOpen", "houseDesign", "estate", "lot", "lotForBuilder"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 2))
    ]),
    ($setup.isDesktop && !$setup.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
          _createVNode($setup["BuilderHeader"], {
            estate: $setup.estate,
            builderLogo: $setup.selectedBuilder?.logo,
            onOnRequestQuotes: $setup.onRequestQuotes
          }, {
            stepper: _withCtx(() => [
              _createVNode($setup["StepperLineDesktop"], {
                tabs: Object.values($setup.CustomizeHouseStepsEnum),
                step: $setup.selectedQuote.currentStep,
                skipStep: $setup.skipStep,
                skipStepIndex: $setup.skipStepIndex,
                onToRequestQuoteForm: $setup.openRequestQuotesFormModal,
                onToReturnMap: $setup.onReturnMap
              }, null, 8, ["tabs", "step", "skipStep", "skipStepIndex"])
            ]),
            _: 1
          }, 8, ["estate", "builderLogo"])
        ]))
      : _createCommentVNode("", true),
    (!$setup.isDesktop && !$setup.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "content-buttons-mobile",
          style: _normalizeStyle({ backgroundColor: $setup.contentBackgroundColor })
        }, [
          ($setup.currentStepIndex == $setup.SelectionStepsIndexEnum.LOT)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button primary customize",
                onClick: $setup.goToNextStep
              }, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("span", null, "Select builder", -1),
                _createElementVNode("img", { src: _imports_1 }, null, -1)
              ]))]))
            : _createCommentVNode("", true),
          ($setup.currentStepIndex >= $setup.SelectionStepsIndexEnum.BUILDER)
            ? (_openBlock(), _createBlock($setup["BuilderButtonsPagination"], {
                key: 1,
                skipStep: $setup.skipStep,
                onToRequestQuoteForm: $setup.openRequestQuotesFormModal,
                onToReturnMap: $setup.onReturnMap
              }, null, 8, ["skipStep"]))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    _createVNode($setup["InitialHoldModal"], {
      isOpen: $setup.isOpenedInitialHoldModal,
      lot: $setup.lotForModal,
      onClose: $setup.onCloseInitialHoldModal,
      onBack: $setup.onCloseInitialHoldModal,
      onSend: $setup.onSendHoldRequest,
      onToPartnerModal: $setup.onOpenPartnerModal
    }, null, 8, ["isOpen", "lot"]),
    _createVNode($setup["InitialHoldWithPartnerModal"], {
      isOpen: $setup.isOpenedInitialHoldModalWithPartner,
      lot: $setup.lotForModal,
      onClose: _cache[4] || (_cache[4] = ($event: any) => ($setup.isOpenedInitialHoldModalWithPartner = false)),
      onBack: $setup.backToSelectHoldType,
      onSend: $setup.onSendHoldRequest
    }, null, 8, ["isOpen", "lot"]),
    _createVNode($setup["SuccessInitialHoldModal"], {
      isOpen: $setup.successfulInitialRequestOpened,
      onClose: _cache[5] || (_cache[5] = ($event: any) => ($setup.successfulInitialRequestOpened = false)),
      lot: $setup.lotForModal
    }, null, 8, ["isOpen", "lot"]),
    _createVNode($setup["BuilderRequestQuoteModal"], {
      house: $setup.selectedHouseDesign,
      estate: $setup.estate,
      lot: $setup.lotForModal,
      isOpen: $setup.isRequestQuotesFormOpened,
      isPhoneVerificationModal: true,
      onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.isRequestQuotesFormOpened = false)),
      onSend: $setup.onSendRequestQuote,
      onOpenPhoneVerificationModal: $setup.onOpenPhoneVerificationModal
    }, null, 8, ["house", "estate", "lot", "isOpen"]),
    _createVNode($setup["PhoneNumberVerificationModal"], {
      isOpen: $setup.isOpenPhoneNumberVerificationModal,
      quote: $setup.quoteForVerificationPhoneNumber,
      onBack: $setup.onClosePhoneVerificationModal,
      onSend: $setup.onSendRequestQuote
    }, null, 8, ["isOpen", "quote"]),
    _createVNode($setup["BuilderQuotesListsModal"], {
      isOpen: $setup.isOpenBuilderQuotesListsModal,
      lot: $setup.lot,
      onClose: _cache[7] || (_cache[7] = ($event: any) => ($setup.isOpenBuilderQuotesListsModal = false)),
      onAddQuote: $setup.onAddQuote,
      onUpdateQuote: $setup.onUpdateQuote,
      onDeleteQuote: $setup.onDeleteQuote,
      onToRequestQuoteForm: $setup.openRequestQuotesForm
    }, null, 8, ["isOpen", "lot"]),
    _createVNode($setup["SuccessBuilderQuoteModal"], {
      isOpen: $setup.isOpenSuccessBuilderQuoteModal,
      onClose: _cache[8] || (_cache[8] = ($event: any) => ($setup.isOpenSuccessBuilderQuoteModal = false)),
      lot: $setup.lotForModal,
      estateId: $setup.estate?._id
    }, null, 8, ["isOpen", "lot", "estateId"])
  ]))
}